import {RootState} from "../store";

export const selectAuthStatus = (state: RootState) => state.auth.status;
export const selectAuthUser = (state: RootState) => state.auth.user;
export const selectAuth = (state: RootState) => state.auth;

